let elements = {
  /**direction type:
  auto
  top
  bottom
  left
  right
  topleft
  topright
  bottomleft
  bottomright
  lefttop
  leftbottom
  righttop
  rightbottom
  **/

  mainImage: {
    imagePath: 'games/page024_game10/img/bcg.jpg',
    width: 1430,
    height: 910,
    pos: {
      x: 259,
      y: 138,
    },
  },
  activeArea: {
    width: 50,
    height: 50,
    fontSize: 35,
    backgroundColor: '#f36f1a',
    color: '#ffffff',
  },
  items: [
    {
      id: '1',
      animation: true,
      direction: 'left',
      textObj: {
        text: 'Kliknij w przycisk <i>Pędzle.</i>',
      },
      audio: {
        src: 'games/page024_game10/audio/z12s24-1.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 772,
        y: 333,
      },
    },
    {
      id: '2',
      // direction: 'left',
      textObj: {
        text: 'Wybierz rodzaj pędzla.',
      },
      audio: {
        src: 'games/page024_game10/audio/z12s24-2.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 542,
        y: 413,
      },
    },
    {
      id: '3',
      direction: 'left',
      textObj: {
        text: 'Kliknij w przycisk <i>Rozmiar.</i>',
      },
      audio: {
        src: 'games/page024_game10/audio/z12s24-3b.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 1025,
        y: 337,
      },
    },
    {
      id: '4',
      direction: 'bottom',
      textObj: {
        text: 'Kliknij w wybrany rozmiar pędzla.',
      },
      audio: {
        src: 'games/page024_game10/audio/z12s24-3.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 1072,
        y: 464,
      },
    },
    {
      id: '5',
      // direction: 'bottom',
      textObj: {
        text: 'Wybierz kolor z palety kolorów.',
      },
      audio: {
        src: 'games/page024_game10/audio/z12s24-4.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 1371,
        y: 228,
      },
    },
    {
      id: '6',
      direction: 'left',
      textObj: {
        text: 'Maluj pędzlem, trzymając wciśnięty lewy przycisk myszy.',
      },
      audio: {
        src: 'games/page024_game10/audio/z12s24-5.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 615,
        y: 874,
      },
    },
  ],
};
export default elements;
